import { lightTheme } from '@/customTheme'
import React from 'react'
import LeftArrowIcon from '@/components/icons/LeftArrowIcon'
import RightArrowIcon from '@/components/icons/RightArrowIcon'
import Icons from '@/scenes/Editor/components/Icons'

type ArrowButtonProps = {
  direction: 'left' | 'right'
  onClick: () => void
  show: boolean
  size?: number
  /** 'chevron' (default) = the small ">" glyph; 'line' = HTML-style line arrow. */
  iconVariant?: 'chevron' | 'line'
}

function ArrowButton({ direction, onClick, show, size, iconVariant = 'chevron' }: ArrowButtonProps) {
  if (!show) return null

  const renderIcon = () => {
    if (iconVariant === 'line') {
      const glyph = Math.max(12, Math.round((size ?? 28) * 0.4))
      return <Icons.ScrollArrow direction={direction} size={glyph} color={lightTheme.colors.blackGray} />
    }
    return direction === 'left' ? <LeftArrowIcon /> : <RightArrowIcon />
  }

  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: lightTheme.colors.white,
        boxShadow: `0 0 ${iconVariant === 'line' ? 20 : 14}px 0 ${lightTheme.colors.secondaryBoxShadow}`,
        width: size ? `${size}px` : '28px',
        height: size ? `${size}px` : '28px',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
      }}
    >
      {renderIcon()}
    </button>
  )
}

export default ArrowButton
